export default {
  en: {
    "dashboard.label.OfficeFilter": "Office Filter",
  "dashboard.label.DateFilter": "Date Filter",
  "dashboard.label.StartDate": "Start Date",
  "dashboard.label.EndDate": "End Date",
  "dashboard.label.Cancel": "Cancel",
  "dashboard.label.Set": "Set",
    "dashboard.label.dashboard": "Dashboard",
    "dashboard.label.active": "Active",
    "dashboard.label.inactive": "Inactive",
    "dashboard.label.allocated": "Allocated",
    "dashboard.label.in_stock": "In Stock",
    "dashboard.label.client_trends_for_head_office":
      "Client Trends for Head Office",
    "dashboard.label.day": "Day",
    "dashboard.label.month": "Month",
    "dashboard.label.week": "Week",
    "dashboard.label.client_details_for_head_office":
      "Client Details for Head Office",
    "dashboard.label.new": "New",
    "dashboard.label.total_clients": "Total Clients",
    "dashboard.label.amount_collected_for_current_month":
      "Amount Collected for current month",
    "dashboard.label.stock_item_details_for_current_month":
      "Stock item details for current Month",
    "dashboard.label.ticket_statistics_for_head_office":
      "Ticket Statistics for Head office",
    "dashboard.label.stb_count": "STB count",
    "dashboard.label.disbursed_amount": "Disbursed amount",
    "dashboard.label.amount_to_be_disburse": "Amount to be disbursed",
    "dashboard.label.total_stbs": "Total STBs",
    "dashboard.label.assigned_stbs": "Assigned STBs",
    "dashboard.label.active_stbs": "Active STBs",
    "dashboard.label.user_name": "User Name",
    "dashboard.label.entity_name": "Entity Name",
    "dashboard.label.status": "Status",
    "dashboard.label.primary_email": "Primary Email",
    "dashboard.label.authenticated": "Authenticated",
    "dashboard.label.user_profile": "User Profile",
    "dashboard.label.recent_frequent_activities": "Recent Frequent Activities",
    "dashboard.label.Amount_Collected_for_Current_Month":
      "Amount Collected for Current Month",
    "dashboard.label.Stock_Item_Details_for_Current_Month":
      "Stock Item Details for Current Month",
    "dashboard.label.Ticket_Statistics_for_Head_Office":
      "Ticket Statistics for Head Office",
    "dashboard.label.STB_Count": "STB Count",
  },

  fr: {
    "dashboard.label.OfficeFilter": "Filtre de bureau",
  "dashboard.label.DateFilter": "Filtre de date",
  "dashboard.label.StartDate": "Date de début",
  "dashboard.label.EndDate": "Date de fin",
  "dashboard.label.Cancel": "Annuler",
  "dashboard.label.Set": "Définir",
    "dashboard.label.dashboard": "Tableau de bord",
    "dashboard.label.active": "Actif",
    "dashboard.label.inactive": "Inactif",
    "dashboard.label.allocated": "Alloué",
    "dashboard.label.in_stock": "En stock",
    "dashboard.label.client_trends_for_head_office":
      "Tendances des clients pour le siège social",
    "dashboard.label.day": "Jour",
    "dashboard.label.month": "Mois",
    "dashboard.label.week": "Semaine",
    "dashboard.label.client_details_for_head_office":
      "Détails du client pour le siège social",
    "dashboard.label.new": "Nouveau",
    "dashboard.label.total_clients": "Total des clients",
    "dashboard.label.amount_collected_for_current_month":
      "Montant collecté pour le mois en cours",
    "dashboard.label.stock_item_details_for_current_month":
      "Détails des articles en stock pour le mois en cours",
    "dashboard.label.ticket_statistics_for_head_office":
      "Statistiques des tickets pour le siège social",
    "dashboard.label.stb_count": "Nombre de STB",
    "dashboard.label.disbursed_amount": "Montant dispersé",
    "dashboard.label.amount_to_be_disburse": "Montant à disperser",
    "dashboard.label.total_stbs": "Total des STB",
    "dashboard.label.assigned_stbs": "STB attribués",
    "dashboard.label.active_stbs": "STB actifs",
    "dashboard.label.user_name": "Nom d'utilisateur",
    "dashboard.label.entity_name": "Nom de l'entité",
    "dashboard.label.status": "Statut",
    "dashboard.label.primary_email": "E-mail principal",
    "dashboard.label.authenticated": "Authentifié",
    "dashboard.label.user_profile": "Profil de l'utilisateur",
    "dashboard.label.recent_frequent_activities":
      "Activités fréquentes récentes",
    "dashboard.label.Amount_Collected_for_Current_Month":
      "Montant Collecté pour le Mois en Cours",
    "dashboard.label.Stock_Item_Details_for_Current_Month":
      "Détails des Articles en Stock pour le Mois en Cours",
    "dashboard.label.Ticket_Statistics_for_Head_Office":
      "Statistiques des Billets pour le Siège",
    "dashboard.label.STB_Count": "Nombre de STB",
  },

  es: {
    "dashboard.label.OfficeFilter": "Filtro de oficina",
  "dashboard.label.DateFilter": "Filtro de fecha",
  "dashboard.label.StartDate": "Fecha de inicio",
  "dashboard.label.EndDate": "Fecha de finalización",
  "dashboard.label.Cancel": "Cancelar",
  "dashboard.label.Set": "Establecer",
    "dashboard.label.dashboard": "Tablero",
    "dashboard.label.active": "Activo",
    "dashboard.label.inactive": "Inactivo",
    "dashboard.label.allocated": "Asignado",
    "dashboard.label.in_stock": "En stock",
    "dashboard.label.client_trends_for_head_office":
      "Tendencias de clientes para la oficina central",
    "dashboard.label.day": "Día",
    "dashboard.label.month": "Mes",
    "dashboard.label.week": "Semana",
    "dashboard.label.client_details_for_head_office":
      "Detalles del cliente para la oficina central",
    "dashboard.label.new": "Nuevo",
    "dashboard.label.total_clients": "Total de clientes",
    "dashboard.label.amount_collected_for_current_month":
      "Cantidad recolectada para el mes actual",
    "dashboard.label.stock_item_details_for_current_month":
      "Detalles del artículo en stock para el mes actual",
    "dashboard.label.ticket_statistics_for_head_office":
      "Estadísticas de tickets para la oficina central",
    "dashboard.label.stb_count": "Cantidad de STB",
    "dashboard.label.disbursed_amount": "Cantidad desembolsada",
    "dashboard.label.amount_to_be_disburse": "Cantidad a desembolsar",
    "dashboard.label.total_stbs": "Total de STBs",
    "dashboard.label.assigned_stbs": "STBs asignados",
    "dashboard.label.active_stbs": "STBs activos",
    "dashboard.label.user_name": "Nombre de usuario",
    "dashboard.label.entity_name": "Nombre de entidad",
    "dashboard.label.status": "Estado",
    "dashboard.label.primary_email": "Correo electrónico principal",
    "dashboard.label.authenticated": "Autenticado",
    "dashboard.label.user_profile": "Perfil de usuario",
    "dashboard.label.recent_frequent_activities":
      "Actividades frecuentes recientes",
    "dashboard.label.Amount_Collected_for_Current_Month":
      "Monto Recaudado para el Mes Actual",
    "dashboard.label.Stock_Item_Details_for_Current_Month":
      "Detalles de Artículos en Stock para el Mes Actual",
    "dashboard.label.Ticket_Statistics_for_Head_Office":
      "Estadísticas de Tickets para la Oficina Central",
    "dashboard.label.STB_Count": "Conteo de STB",
  },

  pt: {
    "dashboard.label.OfficeFilter": "Filtro de escritório",
  "dashboard.label.DateFilter": "Filtro de data",
  "dashboard.label.StartDate": "Data de início",
  "dashboard.label.EndDate": "Data de término",
  "dashboard.label.Cancel": "Cancelar",
  "dashboard.label.Set": "Definir",
    "dashboard.label.dashboard": "Painel",
    "dashboard.label.active": "Ativo",
    "dashboard.label.inactive": "Inativo",
    "dashboard.label.allocated": "Alocado",
    "dashboard.label.in_stock": "Em Estoque",
    "dashboard.label.client_trends_for_head_office":
      "Tendências de Clientes para a Sede",
    "dashboard.label.day": "Dia",
    "dashboard.label.month": "Mês",
    "dashboard.label.week": "Semana",
    "dashboard.label.client_details_for_head_office":
      "Detalhes do Cliente para a Sede",
    "dashboard.label.new": "Novo",
    "dashboard.label.total_clients": "Total de Clientes",
    "dashboard.label.amount_collected_for_current_month":
      "Valor Arrecadado para o mês atual",
    "dashboard.label.stock_item_details_for_current_month":
      "Detalhes do Item em Estoque para o Mês Atual",
    "dashboard.label.ticket_statistics_for_head_office":
      "Estatísticas de Bilhetes para a Sede",
    "dashboard.label.stb_count": "Contagem de STB",
    "dashboard.label.disbursed_amount": "Valor Desembolsado",
    "dashboard.label.amount_to_be_disburse": "Valor a ser Desembolsado",
    "dashboard.label.total_stbs": "Total de STBs",
    "dashboard.label.assigned_stbs": "STBs Atribuídos",
    "dashboard.label.active_stbs": "STBs Ativos",
    "dashboard.label.user_name": "Nome de usuário",
    "dashboard.label.entity_name": "Nome da entidade",
    "dashboard.label.status": "Status",
    "dashboard.label.primary_email": "E-mail principal",
    "dashboard.label.authenticated": "Autenticado",
    "dashboard.label.user_profile": "Perfil do usuário",
    "dashboard.label.recent_frequent_activities":
      "Atividades recentes frequentes",
    "dashboard.label.Amount_Collected_for_Current_Month":
      "Montante Coletado para o Mês Atual",
    "dashboard.label.Stock_Item_Details_for_Current_Month":
      "Detalhes de Itens em Estoque para o Mês Atual",
    "dashboard.label.Ticket_Statistics_for_Head_Office":
      "Estatísticas de Bilhetes para a Sede",
    "dashboard.label.STB_Count": "Contagem de STB",
  },

  zh_CN: {
    "dashboard.label.OfficeFilter": "办公室筛选",
  "dashboard.label.DateFilter": "日期筛选",
  "dashboard.label.StartDate": "开始日期",
  "dashboard.label.EndDate": "结束日期",
  "dashboard.label.Cancel": "取消",
  "dashboard.label.Set": "设置",
    "dashboard.label.dashboard": "仪表板",
    "dashboard.label.active": "活跃的",
    "dashboard.label.inactive": "不活跃的",
    "dashboard.label.allocated": "已分配",
    "dashboard.label.in_stock": "现货",
    "dashboard.label.client_trends_for_head_office": "总部客户趋势",
    "dashboard.label.day": "天",
    "dashboard.label.month": "月",
    "dashboard.label.week": "周",
    "dashboard.label.client_details_for_head_office": "总部客户详情",
    "dashboard.label.new": "新的",
    "dashboard.label.total_clients": "总客户数",
    "dashboard.label.amount_collected_for_current_month": "本月已收款金额",
    "dashboard.label.stock_item_details_for_current_month": "本月库存商品详情",
    "dashboard.label.ticket_statistics_for_head_office": "总部工单统计",
    "dashboard.label.stb_count": "机顶盒数量",
    "dashboard.label.disbursed_amount": "已支付金额",
    "dashboard.label.amount_to_be_disburse": "待支付金额",
    "dashboard.label.total_stbs": "总机顶盒数",
    "dashboard.label.assigned_stbs": "已分配机顶盒数",
    "dashboard.label.active_stbs": "活跃机顶盒数",
    "dashboard.label.user_name": "用户名",
    "dashboard.label.entity_name": "实体名称",
    "dashboard.label.status": "状态",
    "dashboard.label.primary_email": "主要电子邮件",
    "dashboard.label.authenticated": "已认证",
    "dashboard.label.user_profile": "用户资料",
    "dashboard.label.recent_frequent_activities": "最近的频繁活动",
    "dashboard.label.Amount_Collected_for_Current_Month": "本月收集金额",
    "dashboard.label.Stock_Item_Details_for_Current_Month": "本月库存商品明细",
    "dashboard.label.Ticket_Statistics_for_Head_Office": "总部票务统计",
    "dashboard.label.STB_Count": "STB 数量",
  },

  hi: {
    "dashboard.label.OfficeFilter": "कार्यालय फ़िल्टर",
  "dashboard.label.DateFilter": "तारीख़ फ़िल्टर",
  "dashboard.label.StartDate": "प्रारंभ तिथि",
  "dashboard.label.EndDate": "समाप्ति तिथि",
  "dashboard.label.Cancel": "रद्द करें",
  "dashboard.label.Set": "सेट करें",
    "dashboard.label.dashboard": "डैशबोर्ड",
    "dashboard.label.active": "सक्रिय",
    "dashboard.label.inactive": "निष्क्रिय",
    "dashboard.label.allocated": "आवंटित",
    "dashboard.label.in_stock": "स्टॉक में",
    "dashboard.label.client_trends_for_head_office":
      "हेड ऑफिस के लिए ग्राहक रुझान",
    "dashboard.label.day": "दिन",
    "dashboard.label.month": "महीना",
    "dashboard.label.week": "सप्ताह",
    "dashboard.label.client_details_for_head_office":
      "हेड ऑफिस के लिए ग्राहक विवरण",
    "dashboard.label.new": "नया",
    "dashboard.label.total_clients": "कुल ग्राहक",
    "dashboard.label.amount_collected_for_current_month":
      "वर्तमान महीने के लिए जमा राशि",
    "dashboard.label.stock_item_details_for_current_month":
      "वर्तमान महीने के लिए स्टॉक आइटम विवरण",
    "dashboard.label.ticket_statistics_for_head_office":
      "हेड ऑफिस के लिए टिकट सांख्यिकी",
    "dashboard.label.stb_count": "एसटीबी गणना",
    "dashboard.label.disbursed_amount": "वित्तपोषित राशि",
    "dashboard.label.amount_to_be_disburse": "वित्तपोषित किया जाने वाला राशि",
    "dashboard.label.total_stbs": "कुल एसटीबी",
    "dashboard.label.assigned_stbs": "आवंटित एसटीबी",
    "dashboard.label.active_stbs": "सक्रिय एसटीबी",
    "dashboard.label.user_profile": "उपयोगकर्ता प्रोफ़ाइल",
    "dashboard.label.recent_frequent_activities": "हाल की अक्सर गतिविधियाँ",
    "dashboard.label.user_name": "उपयोगकर्ता नाम",
    "dashboard.label.entity_name": "एंटिटी नाम",
    "dashboard.label.status": "स्थिति",
    "dashboard.label.primary_email": "प्राथमिक ईमेल",
    "dashboard.label.authenticated": "प्रमाणित",
    "dashboard.label.Amount_Collected_for_Current_Month":
      "वर्तमान माह के लिए एकत्रित राशि",
    "dashboard.label.Stock_Item_Details_for_Current_Month":
      "वर्तमान माह के लिए स्टॉक आइटम विवरण",
    "dashboard.label.Ticket_Statistics_for_Head_Office":
      "मुख्यालय के लिए टिकट सांख्यिकी",
    "dashboard.label.STB_Count": "STB संख्या",
  },

  ka: {
    "dashboard.label.OfficeFilter": "ოფისის ფილტრი",
  "dashboard.label.DateFilter": "თარიღის ფილტრი",
  "dashboard.label.StartDate": "დაწყების თარიღი",
  "dashboard.label.EndDate": "დასრულების თარიღი",
  "dashboard.label.Cancel": "გაუქმება",
  "dashboard.label.Set": "დაყენება",
    "dashboard.label.dashboard": "საბარათი",
    "dashboard.label.active": "აქტიური",
    "dashboard.label.inactive": "უაქტიურებელი",
    "dashboard.label.allocated": "მიკეტებული",
    "dashboard.label.in_stock": "მარაგში",
    "dashboard.label.client_trends_for_head_office":
      "კლიენტის ტრენდები თავდაცვის ოფისისთვის",
    "dashboard.label.day": "დღე",
    "dashboard.label.month": "თვე",
    "dashboard.label.week": "კვირა",
    "dashboard.label.client_details_for_head_office":
      "კლიენტის დეტალები თავდაცვის ოფისისთვის",
    "dashboard.label.new": "ახალი",
    "dashboard.label.total_clients": "სულ კლიენტები",
    "dashboard.label.amount_collected_for_current_month":
      "მიმდინარე თვის შეკვეთილი",
    "dashboard.label.stock_item_details_for_current_month":
      "მარაგში ნაშთის დეტალები მიმდინარე თვისთვის",
    "dashboard.label.ticket_statistics_for_head_office":
      "ბილეთების სტატისტიკა თავდაცვის ოფისისთვის",
    "dashboard.label.stb_count": "STB რაოდენობა",
    "dashboard.label.disbursed_amount": "გადახდილი თანხა",
    "dashboard.label.amount_to_be_disburse": "გადასახდელი თანხა",
    "dashboard.label.total_stbs": "სულ STBs",
    "dashboard.label.assigned_stbs": "მიკეტებული STBs",
    "dashboard.label.active_stbs": "აქტიური STBs",
    "dashboard.label.user_name": "მომხმარებელის სახელი",
    "dashboard.label.entity_name": "ენთიტის სახელი",
    "dashboard.label.status": "სტატუსი",
    "dashboard.label.primary_email": "პირველადი ელ-ფოსტა",
    "dashboard.label.authenticated": "ავტორიზაცია",
    "dashboard.label.user_profile": "მომხმარებლის პროფილი",
    "dashboard.label.recent_frequent_activities": "ბოლო ხანდახან გარდაიცვლა",
    "dashboard.label.Amount_Collected_for_Current_Month":
      "მიმდინარე თვის შეგროვებული თანხა",
    "dashboard.label.Stock_Item_Details_for_Current_Month":
      "მიმდინარე თვის საწყობის ნივთების დეტალები",
    "dashboard.label.Ticket_Statistics_for_Head_Office":
      "ბილეთების სტატისტიკა სათავო ოფისისთვის",
    "dashboard.label.STB_Count": "STB რაოდენობა",
  },

  lo: {
    "dashboard.label.OfficeFilter": "ຕົວກອງສຳນັກງານ",
  "dashboard.label.DateFilter": "ຕົວກອງວັນທີ",
  "dashboard.label.StartDate": "ວັນເລີ່ມຕົ້ນ",
  "dashboard.label.EndDate": "ວັນສິ້ນສຸດ",
  "dashboard.label.Cancel": "ຍົກເລີກ",
  "dashboard.label.Set": "ຕັ້ງຄ່າ",
    "dashboard.label.dashboard": "ຈັດການຈັດການ",
    "dashboard.label.active": "ປະສົມປັບ",
    "dashboard.label.inactive": "ບໍ່ປະສົມປັບ",
    "dashboard.label.allocated": "ຈໍານວນທີ່ສະຫຼຸບ",
    "dashboard.label.in_stock": "ຢູ່ໃນສາງ",
    "dashboard.label.client_trends_for_head_office":
      "ການຊຸດຂໍ້ມູນລູກຄ້າສ່ວນຫຼຸດ",
    "dashboard.label.day": "ມື້",
    "dashboard.label.month": "ເດືອນ",
    "dashboard.label.week": "ອາທິດ",
    "dashboard.label.client_details_for_head_office":
      "ລາຍລະອຽດຂໍ້ມູນລູກຄ້າສ່ວນຫຼຸດ",
    "dashboard.label.new": "ໃຫມ່",
    "dashboard.label.total_clients": "ຈຳນວນລູກຄ້າທັງໝົດ",
    "dashboard.label.amount_collected_for_current_month":
      "ຈຳນວນເງິນທີ່ບັນທຶກຢູ່ໃນເດືອນປັດຈຸບັນ",
    "dashboard.label.stock_item_details_for_current_month":
      "ລາຍລະອຽດຜະລິດຊັບທີ່ຢູ່ໃນເດືອນປັດຈຸບັນ",
    "dashboard.label.ticket_statistics_for_head_office":
      "ສະຖິຕິທີ່ບັນທຶກຈາກສ່ວນຫຼຸດ",
    "dashboard.label.stb_count": "ຈໍານວນ STB",
    "dashboard.label.disbursed_amount": "ຈໍານວນທີ່ໄດ້ຈ່າຍ",
    "dashboard.label.amount_to_be_disburse": "ຈໍານວນທີ່ຕ້ອງຈ່າຍ",
    "dashboard.label.total_stbs": "ຈຳນວນທັງໝົດ STBs",
    "dashboard.label.assigned_stbs": "ຈຳນວນ STBs ໄດ້ນຳ",
    "dashboard.label.active_stbs": "ຈຳນວນ STBs ປະສົມປັບ",
    "dashboard.label.user_name": "ຊື່ຜູ້ໃຊ້",
    "dashboard.label.entity_name": "ຊື່ຜູ້ເຂົ້າຮ່ວມ",
    "dashboard.label.status": "ສະຖານະ",
    "dashboard.label.primary_email": "ອີເມວທຳມະດາດ",
    "dashboard.label.authenticated": "ຖືກກວດສອບແລ້ວ",
    "dashboard.label.user_profile": "ໂປ້ຕາຂອງຜູ້ໃຊ້",
    "dashboard.label.recent_frequent_activities":
      "ການປະສານທີ່ເປັນຜົນຮັບຫນຶ່ງຫຼ້າສຸດ",
    "dashboard.label.Amount_Collected_for_Current_Month":
      "ຈຳນວນເງິນທີ່ໄດ້ຮັບສຳລັບເດືອນປະຈຸບັນ",
    "dashboard.label.Stock_Item_Details_for_Current_Month":
      "ລາຍລະອຽດສິນຄ້າສຳລັບເດືອນປະຈຸບັນ",
    "dashboard.label.Ticket_Statistics_for_Head_Office":
      "ສະຖິຕິບັດສຳລັບສຳນັກງານໃຫຍ່",
    "dashboard.label.STB_Count": "ຈຳນວນ STB",
  },

  my_MM: {
    "dashboard.label.OfficeFilter": "ရုံးစစ်ထုတ်မှု",
  "dashboard.label.DateFilter": "နေ့စွဲစစ်ထုတ်မှု",
  "dashboard.label.StartDate": "စတင်သည့်ရက်စွဲ",
  "dashboard.label.EndDate": "အဆုံးသတ်ရက်စွဲ",
  "dashboard.label.Cancel": "ဖျက်သိမ်းပါ",
  "dashboard.label.Set": "သတ်မှတ်ပါ",
    "dashboard.label.dashboard": "ဒိုက်တာဘော်ဒါ",
    "dashboard.label.active": "အလုပ်လုပ်နေသည်",
    "dashboard.label.inactive": "လုပ်ဆောင်ခြင်းမရှိသေးပါ",
    "dashboard.label.allocated": "ကာကွယ်ထားသည်",
    "dashboard.label.in_stock": "ရရှိနေသည်",
    "dashboard.label.client_trends_for_head_office":
      "အကြောင်းအရာအခွင့်အရေးများအားစုဆောင်ရေးရင်းနှင့်အခွင့်အရေးအားများ",
    "dashboard.label.day": "ရက်",
    "dashboard.label.month": "လ",
    "dashboard.label.week": "ပတ်",
    "dashboard.label.client_details_for_head_office":
      "အကြောင်းအရာအခွင့်အရေးများအားစုဆောင်ရေးရင်း",
    "dashboard.label.new": "အသစ်",
    "dashboard.label.total_clients": "စုစုပေါင်းကလေးများ",
    "dashboard.label.amount_collected_for_current_month":
      "ယခုလက်ရှိလစားလှယ်ငွေပမာဏ",
    "dashboard.label.stock_item_details_for_current_month":
      "လစားလှယ်လိုင်စင်အသစ်လိုင်စင်ပုံစံပြင်",
    "dashboard.label.ticket_statistics_for_head_office":
      "အကြောင်းအရာများစုဆောင်ရေးရင်း",
    "dashboard.label.stb_count": "STB ကုန်အရေတွက်",
    "dashboard.label.disbursed_amount": "ပေးချေသည့်ငွေပမာဏ",
    "dashboard.label.amount_to_be_disburse": "ပေးချေရေသောငွေပမာဏ",
    "dashboard.label.total_stbs": "စုစုပေါင်း STBs",
    "dashboard.label.assigned_stbs": "ထုတ်ပြန်သော STBs",
    "dashboard.label.active_stbs": "အလုပ်လုပ်နေသည် STBs",
    "dashboard.label.user_name": "အသုံးပြုသူအမည်",
    "dashboard.label.entity_name": "စာရင်းအမည်",
    "dashboard.label.status": "အခြေအနေ",
    "dashboard.label.primary_email": "ပထမ အီးမေးလ်",
    "dashboard.label.authenticated": "အတည်ပြုခြင်းနှင့်ခံရသည်",
    "dashboard.label.user_profile": "အသုံးပြုသူယေဘုယျ",
    "dashboard.label.recent_frequent_activities":
      "နောက်ဆုံးအသက်များစွာလှပတ်တွက်ခဲ့သည်",
    "dashboard.label.Amount_Collected_for_Current_Month":
      "လက်ရှိလအတွက်စုဆောင်းငွေပမာဏ",
    "dashboard.label.Stock_Item_Details_for_Current_Month":
      "လက်ရှိလအတွက်ပစ္စည်းအသေးစိတ်",
    "dashboard.label.Ticket_Statistics_for_Head_Office":
      "ဌာနချုပ်အတွက်တစ်ကွက်စာရင်းဇယား",
    "dashboard.label.STB_Count": "STB အရေအတွက်",
  },

  my: {
    "dashboard.label.OfficeFilter": "ရုံးစစ်ထုတ်မှု",
  "dashboard.label.DateFilter": "နေ့စွဲစစ်ထုတ်မှု",
  "dashboard.label.StartDate": "စတင်သည့်ရက်စွဲ",
  "dashboard.label.EndDate": "အဆုံးသတ်ရက်စွဲ",
  "dashboard.label.Cancel": "ဖျက်သိမ်းပါ",
  "dashboard.label.Set": "သတ်မှတ်ပါ",
    "dashboard.label.dashboard": "ဒိုက်တာဘော်ဒါ",
    "dashboard.label.active": "လက်ရှိနေသော",
    "dashboard.label.inactive": "မလုပ်ကြောင်းပါ",
    "dashboard.label.allocated": "တရားဝင်သည်",
    "dashboard.label.in_stock": "ဝယ်ယူထားသော",
    "dashboard.label.client_trends_for_head_office":
      "အကယ်၍ စစ်ဆေးရန်ရည်ရွယ်ချက်များ",
    "dashboard.label.day": "ရက်",
    "dashboard.label.month": "လ",
    "dashboard.label.week": "အပတ်",
    "dashboard.label.client_details_for_head_office":
      "အကယ်၍ ရာထူးရေးအသေးစိတ်များ",
    "dashboard.label.new": "အသစ်",
    "dashboard.label.total_clients": "စုစုပေါင်း ကလေးများ",
    "dashboard.label.amount_collected_for_current_month":
      "ယခုလက်ရှိလှပ်ရှင်းထားသည်အပေါင်းပမာဏ",
    "dashboard.label.stock_item_details_for_current_month":
      "ယခုလက်ရှိမှတ်ပုံစံအသစ်များ",
    "dashboard.label.ticket_statistics_for_head_office":
      "အကယ်၍ စစ်ဆေးရန်ထိန်းသိမ်းမှုများ",
    "dashboard.label.stb_count": "STB ကုန်အရေတွက်",
    "dashboard.label.disbursed_amount": "ပြန်ပေးခဲ့သည်ငွေပမာဏ",
    "dashboard.label.amount_to_be_disburse": "ပေးခဲ့ရေသောငွေပမာဏ",
    "dashboard.label.total_stbs": "စုစုပေါင်း STBs",
    "dashboard.label.assigned_stbs": "ပေးခဲ့သော STBs",
    "dashboard.label.active_stbs": "လက်ရှိနေသော STBs",
    "dashboard.label.user_name": "အသုံးပြုသူအမည်",
    "dashboard.label.entity_name": "စာရင်းအမည်",
    "dashboard.label.status": "အခြေအနေ",
    "dashboard.label.primary_email": "ပထမ အီးမေးလ်",
    "dashboard.label.authenticated": "အတည်ပြုခြင်းနှင့်ခံရသည်",
    "dashboard.label.user_profile": "အသုံးပြုသူယေဘုယျ",
    "dashboard.label.recent_frequent_activities":
      "နောက်ဆုံးအသက်များစွာလှပတ်တွက်ခဲ့သည်",
    "dashboard.label.Amount_Collected_for_Current_Month":
      "လက်ရှိလအတွက်ရုံးပေါင်းသင့်ငွေပမာဏ",
    "dashboard.label.Stock_Item_Details_for_Current_Month":
      "လက်ရှိလအတွက်ပစ္စည်းအသေးစိတ်",
    "dashboard.label.Ticket_Statistics_for_Head_Office":
      "ဌာနချုပ်အတွက်တစ်ကွက်စာရင်းဇယား",
    "dashboard.label.STB_Count": "STB အရေအတွက်",
  },

  vi: {
    "dashboard.label.OfficeFilter": "Bộ lọc văn phòng",
  "dashboard.label.DateFilter": "Bộ lọc ngày",
  "dashboard.label.StartDate": "Ngày bắt đầu",
  "dashboard.label.EndDate": "Ngày kết thúc",
  "dashboard.label.Cancel": "Hủy",
  "dashboard.label.Set": "Thiết lập",
    "dashboard.label.dashboard": "Bảng điều khiển",
    "dashboard.label.active": "Hoạt động",
    "dashboard.label.inactive": "Không hoạt động",
    "dashboard.label.allocated": "Đã phân bổ",
    "dashboard.label.in_stock": "Trong kho",
    "dashboard.label.client_trends_for_head_office":
      "Xu hướng khách hàng cho trụ sở chính",
    "dashboard.label.day": "Ngày",
    "dashboard.label.month": "Tháng",
    "dashboard.label.week": "Tuần",
    "dashboard.label.client_details_for_head_office":
      "Chi tiết khách hàng cho trụ sở chính",
    "dashboard.label.new": "Mới",
    "dashboard.label.total_clients": "Tổng số khách hàng",
    "dashboard.label.amount_collected_for_current_month":
      "Số tiền thu được cho tháng hiện tại",
    "dashboard.label.stock_item_details_for_current_month":
      "Chi tiết mặt hàng trong kho cho tháng hiện tại",
    "dashboard.label.ticket_statistics_for_head_office":
      "Thống kê vé cho trụ sở chính",
    "dashboard.label.stb_count": "Số lượng STB",
    "dashboard.label.disbursed_amount": "Số tiền đã chi",
    "dashboard.label.amount_to_be_disburse": "Số tiền cần chi",
    "dashboard.label.total_stbs": "Tổng số STB",
    "dashboard.label.assigned_stbs": "STB đã phân bổ",
    "dashboard.label.active_stbs": "STB hoạt động",
    "dashboard.label.user_name": "Tên người dùng",
    "dashboard.label.entity_name": "Tên thực thể",
    "dashboard.label.status": "Trạng thái",
    "dashboard.label.primary_email": "Email chính",
    "dashboard.label.authenticated": "Đã xác thực",
    "dashboard.label.user_profile": "Hồ sơ người dùng",
    "dashboard.label.recent_frequent_activities":
      "Hoạt động thường xuyên gần đây",
    "dashboard.label.Amount_Collected_for_Current_Month":
      "Số tiền thu được trong tháng hiện tại",
    "dashboard.label.Stock_Item_Details_for_Current_Month":
      "Chi tiết mặt hàng tồn kho trong tháng hiện tại",
    "dashboard.label.Ticket_Statistics_for_Head_Office":
      "Thống kê vé cho văn phòng chính",
    "dashboard.label.STB_Count": "Số lượng STB",
  },
};
